export const enum NotificationIds {
  SYMPTOM_TRACKING_REMINDER = 1,
  PERIOD_REMINDER_D_MINUS_3 = 2,
  PERIOD_REMINDER_D_MINUS_1 = 3,
  PERIOD_REMINDER_D_PLUS_1 = 4,
  PERIOD_REMINDER_D_PLUS_4 = 5,
  PERIOD_REMINDER_D_PLUS_10 = 6,
  PREVENTION_JOURNEY_1 = 7,
  PREVENTION_JOURNEY_2 = 8,
  PREVENTION_JOURNEY_3 = 9,
  PREVENTION_JOURNEY_4 = 10,
}

export const PERIOD_REMINDER_IDS = [
  NotificationIds.PERIOD_REMINDER_D_MINUS_3,
  NotificationIds.PERIOD_REMINDER_D_MINUS_1,
  NotificationIds.PERIOD_REMINDER_D_PLUS_1,
  NotificationIds.PERIOD_REMINDER_D_PLUS_4,
  NotificationIds.PERIOD_REMINDER_D_PLUS_10,
];

export const PREVENTION_JOURNEY_IDS = [
  NotificationIds.PREVENTION_JOURNEY_1,
  NotificationIds.PREVENTION_JOURNEY_2,
  NotificationIds.PREVENTION_JOURNEY_3,
  NotificationIds.PREVENTION_JOURNEY_4,
];

export const PREVENTION_JOURNEY_COUNT = PREVENTION_JOURNEY_IDS.length;

const enum ActionTypes {
  SYMPTOM_TRACKING_REMINDER = 'symptomTrackingReminder',
  PERIOD_REMINDER = 'periodReminder',
  PREVENTION_JOURNEY = 'preventionJourney',
}

export default ActionTypes;
